import userInterfaceSlice from './user-interface-slice';

const { actions, reducer } = userInterfaceSlice;

const userInterfaceStore = {
  ...actions,
  reducer,
};

export { actions };

export default userInterfaceStore;
